module.exports = __webpack_public_path__ + "static/title-bg.33688607.png";